module.exports = __webpack_public_path__ + "28b0c0616496789b0f3705980af9d9bc.jpg";